import { createEntityStore, type EntityState } from '@datorama/akita';
import { type TaxonomyAlignmentResult } from 'types/models';

export type TaxonomyAlignmentResultsState = EntityState<TaxonomyAlignmentResult>;

const store = createEntityStore<TaxonomyAlignmentResultsState>({}, { resettable: true, name: 'taxonomy/alignmentResults' });

export default store;
